<template>
	<div v-loading.fullscreen.lock="fullscreenLoading" element-loading-background="rgba(122, 122, 122, 0.5)">
		<div class="ld-panel-title">
			<router-link to="/hosts" class="back-btn"><span></span>实例详情</router-link>
			<el-link class="right-link" type="primary" :href="domain+'/docs-12137'" target="_blank">快速入门</el-link>
		</div>
		<div class="ld-panel-main" v-loading="loading">
			<div :class="hostData.instance_type == '高可用型' ? 'main-section' : ''">
				<ul class="tab-rewrite" v-if="hostData.instance_type == '高可用型'">
					<li v-for="(item, index) in typeOptions" :key="index" @click="typeChange(index,item.key)" :class="{ 'active': selectedType === index }">{{item.text}}</li>
				</ul>
				<div class="tab-main">
					<el-descriptions title="基本信息" :column="4" border>
						<el-descriptions-item label="实例ID">{{detailData.instance_id}}</el-descriptions-item>
						<el-descriptions-item label="端口">{{detailData.port}}</el-descriptions-item>
						<el-descriptions-item label="实例类型"><el-tag type="success">{{detailData.instance_type}}</el-tag></el-descriptions-item>
						<el-descriptions-item label="初始账号">
						{{dbUser}}<el-button link type="primary" size="small" @click="pwdReset" style="margin-left: 10px;">重置密码</el-button>
						</el-descriptions-item>
						<el-descriptions-item label="实例名称">{{detailData.instance_name}}</el-descriptions-item>
						<el-descriptions-item label="状态"><el-tag type="primary">{{detailData.status}}</el-tag></el-descriptions-item>
						<el-descriptions-item label="IP">{{detailData.ip}}</el-descriptions-item>
						<el-descriptions-item label="开通时间">{{detailData.create_time}}</el-descriptions-item>
						<el-descriptions-item label="外网连接地址">			  
						  <span v-if="detailData.enable_public_network == 2">
							{{ detailData.remote_domain_name }}:{{ detailData.remote_port }}
							<el-text type="info" style="margin-left: 15px;">到期时间：{{detailData.public_network_expire_time}}</el-text>
						  </span>
						  <el-button link type="primary" loading v-else-if="detailData.enable_public_network == 3">开通中</el-button>
						  <el-button v-else link type="primary" @click="dialogGroupVisible = true">开通外网连接</el-button>
						  <el-link class="link" type="warning" :underline="false" :href="domain+'/docs-12236'" target="_blank">如何使用外网连接</el-link>
						</el-descriptions-item>
					</el-descriptions>
					<el-descriptions title="配置信息" :column="4" border>
						<el-descriptions-item label="实例规格">{{detailData.cpu}}核{{detailData.memory}}G</el-descriptions-item>
						<el-descriptions-item label="数据容量">{{detailData.disks}}G</el-descriptions-item>
						<el-descriptions-item label="IOPS">{{detailData.bandwidth}}</el-descriptions-item>
						<el-descriptions-item label="系统版本">{{detailData.version}}</el-descriptions-item>
					</el-descriptions>
					<el-alert title="重要提示：下述各项指标因采集频率等原因，与真实情况存在一定差异，请谨慎使用。" type="warning" show-icon :closable="false" style="margin-top: 20px;" />
					<div class="total-main">
						<div v-loading="loading" class="section" id="chart_cpu"></div>
						<div v-loading="loading" class="section" id="chart_memory"></div>
						<div v-loading="loading" class="section" id="chart_storage"></div>
						<div v-loading="loading" class="section" id="chart_lock"></div>
						<div v-loading="loading" class="section" id="chart_qps"></div>
						<div v-loading="loading" class="section" id="chart_tps"></div>
						<div v-loading="loading" class="section" id="chart_mps"></div>
						<div v-loading="loading" class="section" id="chart_connect"></div>
						<div v-loading="loading" class="section" id="chart_InnodbRead"></div>
						<div v-loading="loading" class="section" id="chart_InnodbWrite"></div>
						<div v-loading="loading" class="section" id="chart_InnodbDelete"></div>
						<div v-loading="loading" class="section" id="chart_InnodbUpdate"></div>
						<div v-loading="loading" class="section" id="chart_ComDelete"></div>
						<div v-loading="loading" class="section" id="chart_ComUpdate"></div>
						<div v-loading="loading" class="section" id="chart_ComInsert"></div>
						<div v-loading="loading" class="section" id="chart_InnodbBuffer"></div>
						<div v-loading="loading" class="section full" id="chart_behindMaster" v-show="selectedType == 1"></div>
					</div>
				</div>
			</div>
		</div>
		<!-- 验证码 -->
		<el-dialog align-center v-model="captchaVisible" title="验证码" width="380">
			<el-alert :title="alertText" type="warning" show-icon :closable="false" />
			<el-image :src="captchaImg" @click="captchaReload" fit="contain" alt="验证码" title="点击刷新" style=" width: 240px; display: block;margin:15px auto;cursor: pointer;" />
		    <el-form>
		      <el-form-item label="图片验证码">
		        <el-input v-model="captchaAnswer" autocomplete="off" placeholder="请输入图片中的验证码" style="width: 145px; margin-right: 8px;" />
				<el-button type="primary" :disabled="codeSend" @click="captchaClick">{{codeSendText}}</el-button>
		      </el-form-item>
			  <el-form-item label="短信验证码">
			    <el-input v-model="smsCode" autocomplete="off" placeholder="请输入手机收到的验证码" style="width: 95%;" />
			  </el-form-item>
		    </el-form>
		    <template #footer>
		      <div class="dialog-footer">
		        <el-button type="primary" @click="pwdResetSubmit">确定</el-button>
		      </div>
		    </template>
		</el-dialog>
		<!-- 外网连接 -->
		<el-dialog width="600" :show-close="false" :close-on-click-modal="false" v-model="dialogGroupVisible" title="外网连接">
			<el-alert title="外网连接最大支持5M带宽，建议使用内网节省带宽费用!" type="warning" show-icon :closable="false" style="margin-bottom: 20px;" />
			<el-form :label-width="formLabelWidth">
				<el-form-item label="所属实例:"><el-text>{{detailData.instance_name}}</el-text></el-form-item>
				<el-form-item label="到期日期:"><el-text>{{detailData.expiration_time}}</el-text></el-form-item>
				<el-form-item label="开通时长:">
					<el-input-number v-model="netText" :min="1" controls-position="right" @change="handleChange" style="width: 110px; margin-right: 8px;" />
					<el-select v-model="netStatus" style="width: 90px" @change="netStatusChange">
						<el-option label="日" value="1" />
						<el-option label="周" value="2" />
						<el-option label="月" value="3" />
					</el-select>
				</el-form-item>
				<p class="net-tip">提示：
					<el-text type="info">一周按七天算，一月按30天算</el-text>
				</p>
				<el-form-item label="配置费用:">
					<el-text style="color: #ff6600;" size="large">{{payMoney}}元</el-text>
				</el-form-item>
				<div class="foot">
					<el-divider content-position="left">费用说明</el-divider>
					<el-text type="info">申请外网连接RDS会产生流量及配置费用。当前外网连接RDS实例产生的外网流量（流入和流出）限时减免，仅收取配置费用。</el-text>
				</div>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="resetForm">取消</el-button>
					<el-button type="primary" @click="submitForm">提交支付</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted,onUnmounted,inject,shallowRef } from 'vue';
	import { useRouter } from 'vue-router';
	import { View,Hide } from '@element-plus/icons-vue'
	import { fetchDetail,statistics,slaveStatus,adminPwdReset,bandwidthPrice,bandwidthOpen } from '@/api/host';
	import { captchaGet,smsCodeGet } from '@/api/home';
	import { ElMessage, ElMessageBox } from 'element-plus'
	import * as echarts from "echarts";

	const router = useRouter();
	const domain = inject('domain');
	const fullscreenLoading = ref(false);
	const dialogGroupVisible = ref(false);
	const formLabelWidth = ref('150');
	const selectedType = ref(0);
	const instance_id = ref('');
	const netText = ref(1);
	const netStatus = ref('1');
	const netType = ref(1);
	const payMoney = ref('1.6');
	const hostId = ref('');
	const congId = ref('');
	const password = ref('******');
	const passFlag = ref(false);
	const loading = ref(true)
	const detailData = ref('');
	const dbUser = ref('');
	const dbPassword = ref('');
	const hostData = ref('');
	const congData = ref('');
	const timeData = ref('');
	const captchaVisible = ref(false);
	const captchaAnswer = ref('');
	const captchaImg = ref('');
	const captchaId = ref('');
	const codeSendText = ref('短信验证码');
	const codeSend = ref(false);
	const codeTime = ref(60);
	const smsCode = ref('');
	const alertText = ref('');
	const cpuChart = ref('');
	const memoryChart = ref('');
	const storageChart = ref('');
	const lockChart = ref('');
	const qpsChart = ref('');
	const tpsChart = ref('');
	const mpsChart = ref('');
	const connectChart = ref('');
	const connectionsChart = ref('');
	const InnodbReadChart = ref('');
	const InnodbWriteChart = ref('');
	const InnodbDeleteChart = ref('');
	const InnodbUpdateChart = ref('');
	const ComDeleteChart = ref('');
	const ComUpdateChart = ref('');
	const ComInsertChart = ref('');
	const InnodbBufferChart = ref('');
	const behindMasterChart = ref('')
	const pagination = reactive({page: 1,size: 30});
	const typeOptions = reactive([
		{
			key: '0',
			text: '主实例'
		},
		{
			key: '1',
			text: '从实例'
		}
	]);

	const fetchDetailF = () => {
		const param = {
			'instance_id':instance_id.value
		}
		fetchDetail(param).then((res) => {
			hostData.value = res.data;
			detailData.value = res.data;
			dbUser.value = res.data.db_user;
			dbPassword.value = res.data.password;
			if(res.data.slave_info != null){
				congData.value = res.data.slave_info;
				congId.value = res.data.slave_info.instance_id;
			}
			loading.value = false;
		})
		statisticsF(hostId.value)
	};
	const typeChange = (key,value) => {
		selectedType.value = key;
		const param = {'instance_id':congId.value}
		switch(value)
		{
			case '0':
				detailData.value = hostData.value;
				statisticsF(hostId.value)
			break;
			case '1':
				detailData.value = congData.value;
				slaveStatus(param).then((res) => {
					detailData.value.status = res.data.status
				})
				statisticsF(congId.value)
			break;
		}
	};
	const passChange = () => {
		passFlag.value = !passFlag.value;
	}
	const captchaChange = () => {
		captchaGet().then((res) => {
			if (res.code == 200) {
				captchaImg.value = res.data.captcha_data;
				captchaId.value = res.data.captcha_id;
			}
		})
	}
	const pwdReset = () => {
		captchaChange()
		captchaAnswer.value = '';
		captchaId.value = '';
		smsCode.value = '';
		captchaVisible.value = !captchaVisible.value;
	}
	const captchaClick = () => {
		const param = {
			'captcha_answer':captchaAnswer.value,
			'captcha_id':captchaId.value
		}
		smsCodeGet(param).then((res) => {
			if (res.code == 200) {
				codeSend.value = true;
				codeSendText.value = codeTime.value+'s后重新发送';
				let timer = setInterval(() => {
				   codeTime.value--;
				   codeSendText.value = codeTime.value + 's后重新发送';
				   if (codeTime.value < 0) {
					   clearInterval(timer);
					   codeSendText.value = '获取验证码';
					   codeTime.value = 60;
					   codeSend.value = false
				   }
				}, 1000)
			}
		})
	}
	const pwdResetSubmit = () => {
		fullscreenLoading.value = true;
		const param = {
			'code':smsCode.value,
			'instance_id':detailData.value.instance_id
		}
		adminPwdReset(param).then((res) => {
			if (res.code == 200) {
				fullscreenLoading.value = false;
				ElMessageBox.confirm(
					'重置密码成功，新密码为：'+res.data+'，请牢记自己的密码，以防丢失！',
					'提示',
					{
						confirmButtonText: '确定',
						showCancelButton: false,
						closeOnClickModal: false,
						showClose:false,
						type: 'success',
					}
				)
				.then(() => {
					captchaVisible.value = !captchaVisible.value;
				})
				.catch(() => {

				})
			}
		})
	}
	const netStatusChange = (val) => {
		switch(val)
		{
			case '1':
				netType.value = 1;
			break;
			case '2':
				netType.value = 7;
			break;
			case '3':
				netType.value = 30;
			break;
		}
		priceChange()
	}
	const handleChange = (val) => {
		priceChange()
	}
	const priceChange = () => {
		const netValue = netText.value * netType.value;
		const param = {'duration':netValue,'instance_id':detailData.value.instance_id}
		bandwidthPrice(param).then((res) => {
			if (res.code == 200) {
				payMoney.value = res.data.price;
			}
		})
	}
	const submitForm = () => {
		const netValue = netText.value * netType.value;
		const param = {'duration':netValue,'instance_id':detailData.value.instance_id}
		bandwidthOpen(param).then((res) => {
			if (res.code == 200) {
				if (res.data == '') {
					ElMessageBox.alert('下单失败', '温馨提示', {
						customClass: 'error-box',
						showConfirmButton: false,
						callback: action => {

						}
					})
				} else{
					window.location.href = domain+"/user/orders/changestype.html?id="+res.data.id;
				}
			}
		})
	}
	const resetForm = () => {
		netType.value = 1;
		netText.value = 1;
		priceChange()
		dialogGroupVisible.value = !dialogGroupVisible.value
	}
	const captchaReload = () => {
		captchaChange()
	}
	const chartCpu = shallowRef(null);
	const chartMemory = shallowRef(null);
	const chartStorage = shallowRef(null);
	const chartLock = shallowRef(null);
	const chartQps = shallowRef(null);
	const chartTps = shallowRef(null);
	const chartMps = shallowRef(null);
	const chartConnect = shallowRef(null);
	const chartInnodbRead = shallowRef(null);
	const chartInnodbWrite = shallowRef(null);
	const chartInnodbDelete = shallowRef(null);
	const chartInnodbUpdate = shallowRef(null);
	const chartComDelete = shallowRef(null);
	const chartComUpdate = shallowRef(null);
	const chartComInsert = shallowRef(null);
	const chartInnodbBuffer = shallowRef(null);
	const chartBehindMaster = shallowRef(null);
	const statisticsF = (hostId) => {
		const param = {
			'page':pagination.page,
			'size':pagination.size,
			'instance_id':hostId
		}
		statistics(param).then((res) => {
			res.data.list.forEach(function(item) {
			  if(item.status_info){
				  item.status_info = JSON.parse(item.status_info);
			  }
			});
			const datas = res.data.list.reverse();
			timeData.value = datas.map(item => item.create_time);
			cpuChart.value = datas.map(item => item.cpu_usage.toFixed(2));
			memoryChart.value = datas.map(item => item.memory_usage.toFixed(2));
			storageChart.value = datas.map(item => item.space_usage);
			lockChart.value = datas.map(item => item.locks_waits);
			qpsChart.value = datas.map(item => parseInt(parseInt(item.status_info.Questions)/parseInt(item.status_info.Uptime)));
			tpsChart.value = datas.map(item => parseInt((parseInt(item.status_info.Com_commit)+parseInt(item.status_info.Com_rollback))/parseInt(item.status_info.Uptime)));
			mpsChart.value = datas.map(item => parseInt((parseInt(item.status_info.Com_insert)+parseInt(item.status_info.Com_insert_select)+parseInt(item.status_info.Com_update)+parseInt(item.status_info.Com_update_multi)+parseInt(item.status_info.Com_delete)+parseInt(item.status_info.Com_delete_multi)+parseInt(item.status_info.Com_replace)+parseInt(item.status_info.Com_replace_select))/parseInt(item.status_info.Uptime)));
			connectChart.value = datas.map(item => parseInt(item.status_info.Threads_connected));
			connectionsChart.value = datas.map(item => parseInt(item.status_info.Connections));
			InnodbReadChart.value = datas.map(item => parseInt(item.status_info.Innodb_data_reads));
			InnodbWriteChart.value = datas.map(item => parseInt(item.status_info.Innodb_data_writes));
			InnodbDeleteChart.value = datas.map(item => parseInt(item.status_info.Innodb_rows_deleted));
			InnodbUpdateChart.value = datas.map(item => parseInt(item.status_info.Innodb_rows_updated));
			ComDeleteChart.value = datas.map(item => parseInt(item.status_info.Com_delete));
			ComUpdateChart.value = datas.map(item => parseInt(item.status_info.Com_update));
			ComInsertChart.value = datas.map(item => parseInt(item.status_info.Com_insert));
			behindMasterChart.value = datas.map(item => parseInt(item.status_info.Seconds_Behind_Master));
			InnodbBufferChart.value = datas.map(item => ((parseInt(item.status_info.Innodb_buffer_pool_pages_total)-parseInt(item.status_info.Innodb_buffer_pool_pages_free))/parseInt(item.status_info.Innodb_buffer_pool_pages_total)*100).toFixed(2));
			cpuChartF();
			memoryChartF();
			storageChartF();
			lockChartF();
			qpsChartF();
			tpsChartF();
			mpsChartF();
			connectChartF();
			InnodbReadChartF();
			InnodbWriteChartF();
			InnodbDeleteChartF();
			InnodbUpdateChartF();
			ComDeleteChartF();
			ComUpdateChartF();
			ComInsertChartF();
			InnodbBufferChartF();
			behindMasterChartF();
		})
	};
	const behindMasterChartF = () => {
		const chart1 = document.getElementById("chart_behindMaster")
		chart1.removeAttribute('_echarts_instance_')
		chartBehindMaster.value = echarts.init(chart1);
		chartBehindMaster.value.setOption({
			title : {
				text: "主从延时",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'主从延时',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: behindMasterChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartBehindMaster.value.resize();
		});
	}
	const InnodbBufferChartF = () => {
		const chart1 = document.getElementById("chart_InnodbBuffer")
		chart1.removeAttribute('_echarts_instance_')
		chartInnodbBuffer.value = echarts.init(chart1);
		chartInnodbBuffer.value.setOption({
			title : {
				text: "Innodb_buffer_pool_pages 使用率",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'Innodb_buffer_pool_pages 使用率',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: InnodbBufferChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartInnodbBuffer.value.resize();
		});
	}
	const ComInsertChartF = () => {
		const chart1 = document.getElementById("chart_ComInsert")
		chart1.removeAttribute('_echarts_instance_')
		chartComInsert.value = echarts.init(chart1);
		chartComInsert.value.setOption({
			title : {
				text: "insert语句频率",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'insert语句频率',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: ComInsertChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartComInsert.value.resize();
		});
	};
	const ComUpdateChartF = () => {
		const chart1 = document.getElementById("chart_ComUpdate")
		chart1.removeAttribute('_echarts_instance_')
		chartComUpdate.value = echarts.init(chart1);
		chartComUpdate.value.setOption({
			title : {
				text: "update语句频率",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'update语句频率',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: ComUpdateChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartComUpdate.value.resize();
		});
	};
	const ComDeleteChartF = () => {
		const chart1 = document.getElementById("chart_ComDelete")
		chart1.removeAttribute('_echarts_instance_')
		chartComDelete.value = echarts.init(chart1);
		chartComDelete.value.setOption({
			title : {
				text: "delete语句频率",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'delete语句频率',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: ComDeleteChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartComDelete.value.resize();
		});
	};
	const InnodbUpdateChartF = () => {
		const chart1 = document.getElementById("chart_InnodbUpdate")
		chart1.removeAttribute('_echarts_instance_')
		chartInnodbUpdate.value = echarts.init(chart1);
		chartInnodbUpdate.value.setOption({
			title : {
				text: "innodb行更新速率",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'innodb行更新速率',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: InnodbUpdateChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartInnodbUpdate.value.resize();
		});
	};
	const InnodbDeleteChartF = () => {
		const chart1 = document.getElementById("chart_InnodbDelete")
		chart1.removeAttribute('_echarts_instance_')
		chartInnodbDelete.value = echarts.init(chart1);
		chartInnodbDelete.value.setOption({
			title : {
				text: "innodb行删除速率",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'innodb行删除速率',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: InnodbDeleteChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartInnodbDelete.value.resize();
		});
	};
	const InnodbWriteChartF = () => {
		const chart1 = document.getElementById("chart_InnodbWrite")
		chart1.removeAttribute('_echarts_instance_')
		chartInnodbWrite.value = echarts.init(chart1);
		chartInnodbWrite.value.setOption({
			title : {
				text: "innodb写吞吐量",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'innodb写吞吐量',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: InnodbWriteChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartInnodbWrite.value.resize();
		});
	};
	const InnodbReadChartF = () => {
		const chart1 = document.getElementById("chart_InnodbRead")
		chart1.removeAttribute('_echarts_instance_')
		chartInnodbRead.value = echarts.init(chart1);
		chartInnodbRead.value.setOption({
			title : {
				text: "innodb读吞吐量",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'innodb读吞吐量',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: InnodbReadChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartInnodbRead.value.resize();
		});
	};
	const connectChartF = () => {
		const chart1 = document.getElementById("chart_connect")
		chart1.removeAttribute('_echarts_instance_')
		chartConnect.value = echarts.init(chart1);
		chartConnect.value.setOption({
			title : {
				text: "活跃连接数",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'活跃连接数',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: connectChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartConnect.value.resize();
		});
	};
	const mpsChartF = () => {
		const chart1 = document.getElementById("chart_mps")
		chart1.removeAttribute('_echarts_instance_')
		chartMps.value = echarts.init(chart1);
		chartMps.value.setOption({
			title : {
				text: "MPS",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'MPS',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: mpsChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartMps.value.resize();
		});
	};
	const tpsChartF = () => {
		const chart1 = document.getElementById("chart_tps")
		chart1.removeAttribute('_echarts_instance_')
		chartTps.value = echarts.init(chart1);
		chartTps.value.setOption({
			title : {
				text: "TPS",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'TPS',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: tpsChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartTps.value.resize();
		});
	};
	const qpsChartF = () => {
		const chart1 = document.getElementById("chart_qps")
		chart1.removeAttribute('_echarts_instance_')
		chartQps.value = echarts.init(chart1);
		chartQps.value.setOption({
			title : {
				text: "QPS",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'QPS',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: qpsChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartQps.value.resize();
		});
	};
	const cpuChartF = () => {
		const chart1 = document.getElementById("chart_cpu")
		chart1.removeAttribute('_echarts_instance_')
		chartCpu.value = echarts.init(chart1);
		chartCpu.value.setOption({
			title : {
				text: "CPU使用率",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'CPU使用率',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: cpuChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartCpu.value.resize();
		});
	};
	const memoryChartF = () => {
		const chart1 = document.getElementById("chart_memory")
		chart1.removeAttribute('_echarts_instance_')
		chartMemory.value = echarts.init(chart1);
		chartMemory.value.setOption({
			title : {
				text: "内存使用率",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'内存使用率',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: memoryChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartMemory.value.resize();
		});
	};
	const storageChartF = () => {
		const chart1 = document.getElementById("chart_storage")
		chart1.removeAttribute('_echarts_instance_')
		chartStorage.value = echarts.init(chart1);
		chartStorage.value.setOption({
			title : {
				text: "MySQL存储空间占用率",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'MySQL存储空间占用率',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: storageChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartStorage.value.resize();
		});
	};
	const lockChartF = () => {
		const chart1 = document.getElementById("chart_lock")
		chart1.removeAttribute('_echarts_instance_')
		chartLock.value = echarts.init(chart1);
		chartLock.value.setOption({
			title : {
				text: "当前行锁等待",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'当前行锁等待数',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: lockChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartLock.value.resize();
		});
	};

	onMounted(() => {
		if(router.currentRoute.value.query){
			instance_id.value = router.currentRoute.value.query.id;
			hostId.value = router.currentRoute.value.query.id;
		}
		alertText.value = '提示：接收验证码的手机号码为 ' + localStorage.getItem('smsPhone');
		fetchDetailF()
	});
	onUnmounted(() => {
		chartCpu.value && chartCpu.value.dispose();
		chartMemory.value && chartMemory.value.dispose();
		chartStorage.value && chartStorage.value.dispose();
		chartLock.value && chartLock.value.dispose();
		chartQps.value && chartQps.value.dispose();
		chartTps.value && chartTps.value.dispose();
		chartMps.value && chartMps.value.dispose();
		chartConnect.value && chartConnect.value.dispose();
		chartInnodbRead.value && chartInnodbRead.value.dispose();
		chartInnodbWrite.value && chartInnodbWrite.value.dispose();
		chartInnodbDelete.value && chartInnodbDelete.value.dispose();
		chartInnodbUpdate.value && chartInnodbUpdate.value.dispose();
		chartComDelete.value && chartComDelete.value.dispose();
		chartComUpdate.value && chartComUpdate.value.dispose();
		chartComInsert.value && chartComInsert.value.dispose();
		chartInnodbBuffer.value && chartInnodbBuffer.value.dispose();
		chartBehindMaster.value && chartBehindMaster.value.dispose();
	})
</script>

<style lang="scss" scoped>
	.main-section{
		border: 1px solid #ddd;
		border-radius: 4px;
		.tab-main{margin:24px}
	}
	.total-main{
		margin-left: -2%;
		margin-top: 20px;
		overflow: hidden;
		.section{
			float: left;
			border: 1px solid #eee;
			border-radius: 10px;
			width: 48%;
			height: 340px;
			padding: 10px;
			margin: 0 0 20px 2%;
		}
		.full{float: none;clear: both; width: 98%;}
	}
	.net-tip{margin: -15px 0 10px 150px; font-size: 12px; color: #999;}
	.pass{float: right;cursor: pointer;}
	.link{margin-left: 20px; text-decoration: underline;}
	::v-deep(.el-divider__text){color: #F56C6C;}
	::v-deep(.el-dialog__body .el-form .el-input){width: 100%;}
	::v-deep(.el-descriptions__label) {width: 140px;}
</style>
